import { toExternalImage } from '../lib/dropify'

export type CometRiskKey = 'presisi' | 'minyak' | 'sayat' | 'kimia'

export type CometGloveDefinition = {
  sku: string
  name: string
  shortName: string
  slug: string
  image: string
  risk: CometRiskKey
  construction: string
  standard: string
  useCase: string
  sizes: string
}

// Product facts and standards are transcribed from docs/apd/produk-comet.md,
// whose source is the official COMET catalogue from PT Alifindo Mitra Bersama.
// Keep the standard codes exact when editing this list.
export const COMET_GLOVE_DEFINITIONS: CometGloveDefinition[] = ([
  {
    sku: 'COMET-CG805WT',
    name: 'Sarung Tangan COMET CG 805 WT PU Palm Fit',
    shortName: 'CG 805 WT',
    slug: 'sarung-tangan-comet-cg-805-wt-pu-palm-fit',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/a689b8c4a46848bcac1cfd8e60598cd8.png',
    risk: 'presisi',
    construction: 'Polyester 13 gauge · PU di telapak',
    standard: 'EN 388:2016 4131X',
    useCase: 'Perakitan, elektronik, otomotif, laboratorium',
    sizes: 'S sampai XXL',
  },
  {
    sku: 'COMET-CG805BK',
    name: 'Sarung Tangan COMET CG 805 BK PU Palm Fit',
    shortName: 'CG 805 BK',
    slug: 'sarung-tangan-comet-cg-805-bk-pu-palm-fit',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/681544cc97734cff9c16905d3f4da986.png',
    risk: 'presisi',
    construction: 'Polyester 13 gauge · PU di telapak',
    standard: 'EN 388:2016 4131X',
    useCase: 'Perakitan, elektronik, otomotif, laboratorium',
    sizes: 'S sampai XXL',
  },
  {
    sku: 'COMET-CG801WT',
    name: 'Sarung Tangan COMET CG 801 WT Liner',
    shortName: 'CG 801 WT',
    slug: 'sarung-tangan-comet-cg-801-wt-liner',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/c3ff287ab5c64eddb6455d8de5621426.png',
    risk: 'presisi',
    construction: 'Polyester 13 gauge · tanpa lapisan',
    standard: 'EN 388:2016 211XX',
    useCase: 'Inspeksi dan penanganan komponen sensitif',
    sizes: 'M dan L',
  },
  {
    sku: 'COMET-CG801BK',
    name: 'Sarung Tangan COMET CG 801 BK Liner',
    shortName: 'CG 801 BK',
    slug: 'sarung-tangan-comet-cg-801-bk-liner',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/f56b7a43b1f64bf29c38f44a477beb1c.png',
    risk: 'presisi',
    construction: 'Polyester 13 gauge · tanpa lapisan',
    standard: 'EN 388:2016 211XX',
    useCase: 'Inspeksi dan penanganan komponen sensitif',
    sizes: 'M dan L',
  },
  {
    sku: 'COMET-CG803WT',
    name: 'Sarung Tangan COMET CG 803 WT PU Top Fit',
    shortName: 'CG 803 WT',
    slug: 'sarung-tangan-comet-cg-803-wt-pu-top-fit',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/e3f4c1978d584e71ad5270a0981238ba.png',
    risk: 'presisi',
    construction: 'Polyester 13 gauge · PU di ujung jari',
    standard: 'EN 388:2016 211XX',
    useCase: 'Perakitan komponen kecil, elektronik, dan PC',
    sizes: 'S dan M',
  },
  {
    sku: 'COMET-CG813',
    name: 'Sarung Tangan COMET CG 813 ESD',
    shortName: 'CG 813 ESD',
    slug: 'sarung-tangan-comet-cg-813-esd',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/fcc44aeb1293413482e5d0a9250b7ff2.png',
    risk: 'presisi',
    construction: 'Rajut carbon · PU di ujung jari',
    standard: 'EN 388:2016 211XX · EN 1149-1:2016',
    useCase: 'Semikonduktor dan perakitan elektronik',
    sizes: 'S sampai L',
  },
  {
    sku: 'COMET-CG905GY',
    name: 'Sarung Tangan COMET CG 905 GY Nitrile',
    shortName: 'CG 905 GY',
    slug: 'sarung-tangan-comet-cg-905-gy-nitrile',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/0ca0232d2c894da79a7e0533925433d0.png',
    risk: 'minyak',
    construction: 'Polyester · nitrile halus di telapak',
    standard: 'EN 388:2016 3141X',
    useCase: 'Engineering, otomotif, dan perawatan mesin berminyak',
    sizes: 'M sampai XL',
  },
  {
    sku: 'COMET-IMPACT',
    name: 'Sarung Tangan COMET Impact Glove',
    shortName: 'Impact Glove',
    slug: 'sarung-tangan-comet-impact-glove',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/bef76c061c4d445fa234d3784f1eb2e0.png',
    risk: 'minyak',
    construction: 'HPPE & fiberglass · foam nitrile · pelindung TPR',
    standard: 'EN 388:2016 4544DP',
    useCase: 'Pekerjaan berat, benturan, dan oli',
    sizes: 'M sampai XXL',
  },
  {
    sku: 'COMET-CG835',
    name: 'Sarung Tangan COMET CG 835 Cut Resistant',
    shortName: 'CG 835',
    slug: 'sarung-tangan-comet-cg-835-cut-resistant',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/246184f971754dad8da1aaf7964377aa.png',
    risk: 'sayat',
    construction: 'HPPE 13 gauge · PU di telapak',
    standard: 'EN 388:2016 4X43C · ANSI A4',
    useCase: 'Penanganan kaca, fabrikasi logam, dan otomotif',
    sizes: 'M dan L',
  },
  {
    sku: 'COMET-CG835L',
    name: 'Sarung Tangan COMET CG 835 Long Cut Resistant 37cm',
    shortName: 'CG 835 Long',
    slug: 'sarung-tangan-comet-cg-835-long-cut-resistant-37cm',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/053b60f8baeb4d6fb03f6f1220ec4a2d.png',
    risk: 'sayat',
    construction: 'HPPE · PU di telapak · panjang 37 cm',
    standard: 'EN 388:2016 4X43C · ANSI A4',
    useCase: 'Perlindungan sayat hingga lengan bawah',
    sizes: 'M dan L',
  },
  {
    sku: 'COMET-CG835NC',
    name: 'Sarung Tangan COMET CG 835 Non-Coat Cut Resistant',
    shortName: 'CG 835 Non-Coat',
    slug: 'sarung-tangan-comet-cg-835-non-coat-cut-resistant',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/8671f09c436e406caa2d86dbeeae974d.png',
    risk: 'sayat',
    construction: 'HPPE · tanpa lapisan',
    standard: 'EN 388:2016 4543D',
    useCase: 'Penanganan kaca, keramik, dan industri tekstil',
    sizes: 'M sampai XL',
  },
  {
    sku: 'COMET-CG855',
    name: 'Sarung Tangan COMET Aramid CG 855',
    shortName: 'Aramid CG 855',
    slug: 'sarung-tangan-comet-aramid-cg-855',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/56c04fc22bae4e2eafbd6b8cf009c362.png',
    risk: 'sayat',
    construction: 'Serat Kevlar · dapat dicuci',
    standard: 'EN 388:2016 1341',
    useCase: 'Pemotongan, engineering, dan penanganan kaca',
    sizes: 'L sampai XXL',
  },
  {
    sku: 'COMET-NF1513',
    name: 'Sarung Tangan COMET NF 1513 Chemical Nitrile',
    shortName: 'NF 1513',
    slug: 'sarung-tangan-comet-nf-1513-chemical-nitrile',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/c40debbaf54a422e8f543691125f9e05.png',
    risk: 'kimia',
    construction: 'Compound acrylonitrile butadiene',
    standard: 'EN 388:2016 4001X · EN 374-1:2016 Type A · EN 374-5:2016',
    useCase: 'Penanganan bahan kimia, oil refining, food processing, dan agrikultur',
    sizes: 'S sampai L',
  },
  {
    sku: 'COMET-CG656',
    name: 'Sarung Tangan COMET CG 656 PVC',
    shortName: 'CG 656 PVC',
    slug: 'sarung-tangan-comet-cg-656-pvc',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/6645de8bc9f140fcbea3b791fb1debd2.png',
    risk: 'kimia',
    construction: 'Lapis PVC · rajut cotton · finishing sandy',
    standard: 'EN 388:2016 4113 · EN 374-1:2016',
    useCase: 'Petrokimia, cold storage, perikanan, dan pergudangan',
    sizes: 'M dan L',
  },
] satisfies CometGloveDefinition[]).map((product) => ({
  ...product,
  image: toExternalImage(product.image, { width: 760, format: 'webp', quality: 76 }),
}))
